import React, { useState, useEffect } from 'react';
import momentTZ from 'moment-timezone';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch, withRouter, Redirect, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  LoginPageNew,
  // LoginPage,
  // ResetPasswordPage,
  ResetPasswordPageNew,
  NewPasswordPage,
  MagicLinkPassword,
  // HomePage,
  HomePageNew,
  // ClassesPage,
  ClassesPageNew,
  OneTimeLoginLink,
  // TrainingPage,
  TrainingPageNew,
  ProfilePageMyAccount,
  ProfilePageUpdatePassword,
  ProfilePageTransaction,
  ProfilePageTransactionNew,
  ProfilePageHistory,
  ProfilePageBilling,
  ProfileSettings,
  ProfilePackages,
  LocationsPage,
  ChooseLocationsPage,
  OnboardingProcess,
  // ChatPage,
  EatLovePageNew,
  BillingInfoNew,
  ContactUsNew,
  MembershipForms,
  FreezeMembership,
  CancelMembership,
  // EatLovePage,
  // ReservationPage,
  VideosDemandPage,
  VideoPage,
  // RegistrationPage,
  RegistrationPageNew,
  // ExperienceUsPage,
  // ProfilePageContactUs,
  AdminPage,
  InviteBenefitPage,
  ProfilePageMembershipSubscription,
  GuestClassesPage,
  PolicyScreen,
  // VaccineVerificationPage,
  Notification,
  AdminLogin,
  AdminHome,
  AdminMonthlyGoals,
  // AdminGympassUnits,
  AdminResetPassword,
  AdminWellhubUnitsHistory,
  SetPasswordPageNew,
} from 'containers';
import { CreateSuccessPage } from 'components';
import RequestSuccessPageNew from './AuthNew/RequestSuccessPage';
import Message from 'components/shared/Message';
import SmallMobileContext from 'context/SmallMobileContext';
import MobileContext from 'context/MobileContext';
import TabletContext from 'context/TabletContext';
import PrivateRoute from 'services/HOCs/privateRoute';
import ScrollToTop from 'services/HOCs/ScrollToTop';
// import NotificationActions from 'store/notifications/actions';
import MessageActions from 'store/messages/actions';
import ErrorActions from 'store/error/actions';
import SessionCallActions from 'store/sessionCall/actions';
import termsAndConditionsActions from 'store/termsAndConditions/actions';
import TnCPopUp from 'components/shared/TnCPopUp';
import PolkMemberPopUp from 'components/shared/PolkMemberPopUp';
import StatusPopup from 'components/shared/StatusPopup';
import { rocket, chartSpline, sparkles, layoutGrid } from 'assets/newIcons';
import history from 'store/history';
import { memberStatuses } from 'enums/memberStatuses';
import vaccineStatuses from 'enums/vaccineStatuses';
import { getSocket } from 'utils/socket';
import { usePrevious } from 'utils/hooks/usePrevious';
import checkIsAdmin from 'services/checkIsAdmin';
import QrCodePage from './QrCodePage';
import NotFoundPage from './NotFoundPage';
import RedirectionPage from './RedirectionPage';
import Logout from './ProfilePage/Logout';
import authUtils from 'utils/auth';
// import { Modal } from './shared/Modal';
// import VaccineVerificationModal from './shared/VaccineVerificationModal';
// import Nutrition from './HomePageNew/Nutrition';
import AdvertisementIframePage from './HomePageNew/Advertsiement/AdvertisementIframePage';
import CancelMembershipIframe from './HomePageNew/CancelMembershipIframe';
import FreezeMembershipIframe from './HomePageNew/FreezeMembershipIframe';

const socket = getSocket();

const App = ({
  isAuth,
  email,
  sfId,
  isTrainer,
  favoriteLocation,
  isOnboardingDisplay,
  // requestNotifications,
  // receiveNotifications,
  receiveMessage,
  error,
  errorType,
  clearError,
  // setMessage,
  memberStatus,
  // membership,
  receiveReadMessages,
  // loadMessages,
  // messagesHistory,
  incomingCall,
  incomingCallRejected,
  vaccineStatus,
  loadTermsAgreementValues,
  loadPopupDetails,
  termsAgreementValues,
  popupDetails,
  formsDetails,
  cancelIframeDetails,
  freezeIframeDetails,
  isPolkMember,
}) => {
  const [isSmallMobile, setIsSmallMobile] = useState(
    document.documentElement.clientWidth <= 450
  );
  const [isMobile, setIsMobile] = useState(document.documentElement.clientWidth <= 768);
  const [isTablet, setIsTablet] = useState(document.documentElement.clientWidth <= 992);
  const [openTncPopUp, setOpenTncPopUp] = useState(false);
  const [openPolkPopUp, setOpenPolkPopUp] = useState(false);
  const [openStatusPopup, setOpenStatusPopup] = useState(false);
  const [, setOpenModal] = useState(false);
  const [isCancelIframeEnabled, setIsCancelIframeEnabled] = useState(false);
  const [isFreezeIframeEnabled, setIsFreezeIframeEnabled] = useState(false);

  useEffect(() => {
    if (Object.keys(formsDetails).length !== 0) {
      const cancelForm = formsDetails.find(form =>
        form?.name?.toLowerCase().includes('cancel')
      );
      const freezeForm = formsDetails.find(form =>
        form?.name?.toLowerCase().includes('freeze')
      );
      const isCancelEnabled = cancelForm && cancelForm.c2SEnable;
      const isFreezeEnabled = freezeForm && freezeForm.c2SEnable;
      const cancelIframeURLData =
        Object.keys(cancelIframeDetails).length !== 0 && cancelIframeDetails.success;
      const freezeIframeURLData =
        Object.keys(freezeIframeDetails).length !== 0 && freezeIframeDetails.success;

      // Enable iframe only if both conditions are met:
      setIsCancelIframeEnabled(isCancelEnabled && cancelIframeURLData);
      setIsFreezeIframeEnabled(isFreezeEnabled && freezeIframeURLData);
    }
  }, [formsDetails, cancelIframeDetails, freezeIframeDetails]);

  const checkIsAdminRestrictions = checkIsAdmin(email);
  const membershipRestrictions =
    memberStatus !== memberStatuses.onHold && memberStatus !== memberStatuses.notActive;
  const prevVaccineStatus = usePrevious(vaccineStatus);

  const path = window.location.pathname;
  const isAdminAuth = authUtils.getAdminToken() ? true : false;
  const userId = useSelector(state => state?.auth?.profile?.userID);
  const newUserId = useSelector(state => state?.auth?.user?.idCA);
  const tncRoute = useSelector(
    state => state?.termsAndConditions?.popupDetails?.tearmsAndCoditionUrl
  );
  const tncPathname = tncRoute && new URL(tncRoute).pathname;
  const dispatch = useDispatch();

  // Check localStorage to override onboarding display if user completed it
  const getEffectiveOnboardingDisplay = () => {
    if (!isAuth) return false; // Not authenticated users should go to login, not onboarding

    const isOnboardingCompleted = localStorage.getItem('onboardingCompleted') === 'true';

    // If user completed onboarding locally, always return false
    if (isOnboardingCompleted) {
      return false;
    }

    // SIMPLE FIX: If user is in onboarding process (browser close/new tab protection)
    const isOnboardingInProgress =
      localStorage.getItem('onboardingInProgress') === 'true';
    if (isOnboardingInProgress) {
      return true;
    }

    // Special case: If user is currently on /onboarding page and refreshes,
    // assume they should stay on onboarding (they haven't completed it yet)
    const currentPath = window.location.pathname;
    if (currentPath === '/onboarding') {
      // Only mark as in progress if user hasn't completed onboarding and doesn't have favoriteLocation
      if (!favoriteLocation && !isOnboardingCompleted) {
        localStorage.setItem('onboardingInProgress', 'true');
        return true;
      }
      // If user completed onboarding, don't allow access to onboarding
      return false;
    }

    // SAFETY CHECK: If isOnboardingDisplay is true but favoriteLocation exists,
    // user has already completed onboarding - don't redirect to onboarding
    if (isOnboardingDisplay && favoriteLocation) {
      return false;
    }

    // Otherwise use the value from Redux state (which comes from API)
    return isOnboardingDisplay;
  };

  const effectiveIsOnboardingDisplay = getEffectiveOnboardingDisplay();

  const handlePopupClick = () => {
    const tncRoute = popupDetails?.tearmsAndCoditionUrl;
    const decodedUrl = decodeURIComponent(tncRoute);
    window.open(decodedUrl, '_blank');
  };

  useEffect(() => {
    if (isAuth && path === '/magic-link-password') {
      dispatch({
        type: 'LOGOUT_REQUEST',
      });
    }
  }, [isAuth, path, dispatch]);

  useEffect(() => {
    if (isAuth && !favoriteLocation && path !== '/documentsign') {
      loadTermsAgreementValues(newUserId);
      loadPopupDetails(newUserId);
    } else if (isAuth && favoriteLocation && path !== '/documentsign' && userId) {
      loadTermsAgreementValues(userId);
      loadPopupDetails(userId);
    }
  }, [isAuth, userId, favoriteLocation, path]);

  useEffect(() => {
    if (Object.keys(termsAgreementValues).length !== 0) {
      // Check if user has previously closed the popup
      const hasClosedPopup = localStorage.getItem('tncPopupClosed') === 'true';

      if (!termsAgreementValues?.isdocumentcrossiconenable && hasClosedPopup) {
        localStorage.removeItem('tncPopupClosed');
      }

      if (
        termsAgreementValues?.isDocumentPopUp &&
        !termsAgreementValues?.liabilityWaiver &&
        !hasClosedPopup
      ) {
        setOpenTncPopUp(true);
      } else {
        setOpenTncPopUp(false);
      }
    }
  }, [termsAgreementValues]);

  useEffect(() => {
    const isPolkLocal = localStorage.getItem('isPolkMember') === 'true';
    if (
      isAuth &&
      (isPolkMember || isPolkLocal) &&
      location.pathname !== '/onboarding' &&
      localStorage.getItem('tncApiChecked') === 'true' &&
      !openTncPopUp
    ) {
      if (localStorage.getItem('polkPopupShown') !== '1') {
        const hasClosedPopup = localStorage.getItem('polkMemberPopupClosed') === 'true';
        if (!hasClosedPopup) {
          localStorage.setItem('polkPopupShown', '1');
        }
        setOpenPolkPopUp(!hasClosedPopup);
      }
      // polkPopupShown='1': popup already shown — don't close it via else,
      // let the user dismiss it themselves
    } else {
      setOpenPolkPopUp(false);
    }
  }, [isAuth, isPolkMember, location, openTncPopUp, termsAgreementValues]);

  useEffect(() => {
    const isExcludedPath =
      location.pathname === '/onboarding' ||
      location.pathname === '/documentsign' ||
      location.pathname === '/magic-link-password' ||
      location.pathname === '/our-classes';
    const isConfigLoaded = Object.keys(termsAgreementValues || {}).length !== 0;
    const isReadyToShow = isExcludedPath
      ? false
      : isAuth
      ? isConfigLoaded && !openTncPopUp && !openPolkPopUp
      : true;

    if (isReadyToShow) {
      if (sessionStorage.getItem('statusPopupShown') !== '1') {
        const hasClosedPopup = sessionStorage.getItem('statusPopupClosed') === 'true';
        if (!hasClosedPopup) {
          sessionStorage.setItem('statusPopupShown', '1');
        }
        setOpenStatusPopup(!hasClosedPopup);
      }
      // statusPopupShown='1': popup already shown — don't close it via else,
      // let the user dismiss it themselves
    } else {
      setOpenStatusPopup(false);
    }
  }, [isAuth, location, openTncPopUp, openPolkPopUp, termsAgreementValues]);

  const handleCloseStatusPopup = () => {
    sessionStorage.setItem('statusPopupClosed', 'true');
    setOpenStatusPopup(false);
  };

  useEffect(() => {
    const checkShutdownRedirect = () => {
      const isAfterShutdown = momentTZ
        .tz('America/Los_Angeles')
        .isAfter(momentTZ.tz('2026-07-14 00:00', 'America/Los_Angeles'));
      const currentPath = location.pathname.replace(/\/$/, '') || '/';
      if (isAfterShutdown && currentPath !== '/our-classes') {
        window.location.href = 'http://fitnesssf.com/';
      }
    };
    checkShutdownRedirect();
    const intervalId = setInterval(checkShutdownRedirect, 60000);
    return () => clearInterval(intervalId);
  }, [location]);

  const handleResize = () => {
    const { clientWidth } = document.documentElement;
    setIsSmallMobile(clientWidth <= 450);
    setIsMobile(clientWidth <= 768);
    setIsTablet(clientWidth <= 991);
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src =
      'https://cmp.osano.com/16BlRXURPUpNw6l5g/03edbc42-8510-4a2b-81f6-795a5906a26f/osano.js';
    script.async = true;
    document.head.appendChild(script);
    window.addEventListener('resize', handleResize);
    localStorage.removeItem('tncPopupClosed');
  }, []);

  useEffect(() => {
    if (vaccineStatus === vaccineStatuses.notYetUploaded) setOpenModal(true);
    if (
      vaccineStatus === vaccineStatuses.pendingConfirmation &&
      prevVaccineStatus === vaccineStatuses.notYetUploaded
    ) {
      setOpenModal(true);
    }
    // eslint-disable-next-line
  }, [vaccineStatus]);

  useEffect(() => {
    const body = document.getElementById('root');
    if (isAuth) body.className = 'logged-in';
    if (!isAuth) body.className = 'logged-out';
  }, [isAuth]);

  useEffect(() => {
    if (isAuth) {
      // if (!socket.hasListeners('notification'))
      //   socket.on('notification', notifications => {
      //     receiveNotifications(notifications);
      //   });

      if (!socket.hasListeners('message'))
        socket.on('message', message => {
          receiveMessage(message);
        });
      if (!socket.hasListeners('message read success'))
        socket.on('message read success', data => {
          receiveReadMessages(data);
        });
      socket.on('request-call', data => {
        incomingCall(data.friendId, data.friendSocketId);
      });
      if (!socket.hasListeners('stop-session-call'))
        socket.on('stop-session-call', () => {
          if (!isTrainer) incomingCallRejected();
        });
      if (!socket.hasListeners('peer-disconnected'))
        socket.on('peer-disconnected', () => {
          if (!isTrainer) incomingCallRejected();
        });
    }
    // eslint-disable-next-line
  }, [
    isAuth,
    incomingCall,
    receiveMessage,
    // receiveNotifications,
    receiveReadMessages,
  ]);

  // useEffect(() => {
  //   // commented reason: chat feature was hided
  //   if (
  //     window.location.pathname !== '/login' &&
  //     window.location.pathname !== '/chat' &&
  //     !messagesHistory.length
  //   )
  //   loadMessages();
  // }, [loadMessages]);
  useEffect(
    () => {
      if (
        window.location.pathname !== '/login' &&
        window.location.pathname !== '/join' &&
        window.location.pathname !== '/experience-us'
      ) {
        // requestNotifications();
        history.listen(props => {
          // requestNotifications();
        });
      }
    },
    [
      // requestNotifications
    ]
  );

  useEffect(() => {
    if (sfId) {
      window.gtag('event', 'login', {
        event_label: `User sfId=${sfId} logged in`,
        event_category: 'login',
      });
      window.gtag('set', { user_id: sfId });
    }
  }, [sfId]);

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const mobileFormURL = params.get('formURL');

  const mobileURL =
    path === '/update-password' ||
    path === '/my-account' ||
    path === '/manage_memberShip' ||
    path === '/mental_wellness';

  useEffect(() => {
    if (
      !isAuth &&
      path !== '/login' &&
      path !== '/reset_password' &&
      path !== '/request_success' &&
      path !== '/onboarding' &&
      path !== '/' &&
      path !== '/magic-link-password' &&
      path !== '/create_success' &&
      path !== '/new_password' &&
      path !== '/'
    ) {
      // Save the current path for redirection after login
      sessionStorage.setItem('callback', path);
    }
  }, [isAuth, path]);

  useEffect(() => {
    if (path === '/login' && navigator.cookieEnabled) {
      document.cookie = `admin_token=; path=/; max-age=0 `;
    }
  }, [path]);

  const redirect = effectiveIsOnboardingDisplay ? '/onboarding' : '/login';

  const adminRedirect = isAdminAuth ? '/admin' : '/admin/login';

  const allowLimited = isAuth && !effectiveIsOnboardingDisplay;
  const isPolkMemberLocal = localStorage.getItem('isPolkMember') === 'true';

  // let locationNames = [
  //   'marin',
  //   'embarcadero',
  //   'fillmore',
  //   'transbay',
  //   'mid_market',
  //   'oakland',
  //   'soma',
  //   'castro',
  // ];
  // const currentPath = window.location.pathname.substring(1);
  // const isLocationValid = locationNames.includes(currentPath);
  return (
    <>
      <TabletContext.Provider value={isTablet}>
        <MobileContext.Provider value={isMobile}>
          <SmallMobileContext.Provider value={isSmallMobile}>
            <React.StrictMode>
              <ScrollToTop>
                {/* <Modal
                  isOpened={
                    isOpenModal &&
                    window.location.pathname !== '/verify-status'
                  }
                  setIsOpened={() => setOpenModal(!isOpenModal)}
                  wrapperStyles={{
                    width: '315px',
                    height:
                      vaccineStatus === vaccineStatuses.notYetUploaded
                        ? '340px'
                        : '230px',
                  }}
                >
                  <VaccineVerificationModal
                    setOpenModal={setOpenModal}
                    vaccineStatus={vaccineStatus}
                  />
                </Modal> */}
                <Switch>
                  {/* Location routes Logic */}
                  {/* {locationNames.includes(currentPath) ? (
                    <Route path="/:location" exact>
                      <RegistrationPageNew
                        isLocationValid={isLocationValid}
                        locationRoute={currentPath}
                      />
                    </Route>
                  ) : (
                    <Route path="/" exact>
                      <RegistrationPageNew
                        isLocationValid={isLocationValid}
                        locationRoute="undefined"
                      />
                    </Route>
                  )} */}

                  {/* <PrivateRoute
                    allow={!isAuth}
                    path="/join"
                    exact
                    component={RegistrationPageNew}
                  /> */}

                  {/*  <PrivateRoute
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/"
                    exact
                    component={HomePage}
                    redirectTo={redirect}
                  /> */}
                  <PrivateRoute
                    allow={allowLimited}
                    path="/"
                    exact
                    component={HomePageNew}
                    redirectTo={redirect}
                  />

                  <PrivateRoute
                    allow={!isAuth && !isAdminAuth}
                    path="/admin/login"
                    exact
                    component={AdminLogin}
                    redirectTo={adminRedirect}
                  />

                  <PrivateRoute
                    allow={!isAuth && isAdminAuth}
                    path="/admin"
                    exact
                    component={AdminHome}
                    redirectTo={adminRedirect}
                  />

                  <PrivateRoute
                    allow={!isAuth && isAdminAuth}
                    path="/admin/monthly-goals"
                    exact
                    component={AdminMonthlyGoals}
                    redirectTo={adminRedirect}
                  />

                  {/* <PrivateRoute
                    allow={!isAuth && isAdminAuth}
                    path="/admin/daily-gympass-units"
                    exact
                    component={AdminGympassUnits}
                    redirectTo={adminRedirect}
                  /> */}

                  <PrivateRoute
                    allow={!isAuth && !isAdminAuth}
                    path="/admin/reset-password"
                    exact
                    component={AdminResetPassword}
                  />

                  <PrivateRoute
                    allow={!isAuth && isAdminAuth}
                    path="/admin/wellhub-units-history"
                    exact
                    component={AdminWellhubUnitsHistory}
                    redirectTo={adminRedirect}
                  />
                  {/* <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/nutrition"
                    exact
                    component={EatLovePage}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/classes"
                    exact
                    component={ClassesPage}
                    redirectTo={redirect}
                  /> */}
                  <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/classes"
                    exact
                    component={ClassesPageNew}
                    redirectTo={redirect}
                  />
                  {/* <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/on_demand"
                    exact
                    component={VideosDemandPage}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/on_demand/:section"
                    exact
                    component={VideoPage}
                    redirectTo={redirect}
                  /> */}

                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/reservation"
                    exact
                    component={QrCodePage}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={isAuth ? allowLimited : !isAuth}
                    path="/verify-status"
                    exact
                    component={VaccineVerificationPage}
                  /> */}
                  {/* <PrivateRoute
                  allow={allow}
                  path="/chat"
                  exact
                  component={ChatPage}
                  redirectTo={redirect}
                /> */}
                  {/* <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/training"
                    exact
                    component={TrainingPage}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/locations"
                    exact
                    component={LocationsPage}
                    redirectTo={redirect}
                  /> */}
                  <PrivateRoute
                    allow={allowLimited && !isPolkMemberLocal}
                    path="/nutrition"
                    exact
                    component={EatLovePageNew}
                    redirectTo={isPolkMemberLocal ? '/' : redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/statement-checkins"
                    exact
                    component={ProfilePageTransactionNew}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/training"
                    exact
                    component={TrainingPageNew}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/mvpTraining"
                    exact
                    component={AdvertisementIframePage}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited && termsAgreementValues?.enablePayments !== false}
                    path="/billing-info"
                    exact
                    component={BillingInfoNew}
                    redirectTo={
                      termsAgreementValues?.enablePayments === false ? '/' : redirect
                    }
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/contact-us"
                    exact
                    component={ContactUsNew}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/membership-form"
                    exact
                    component={MembershipForms}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/membership-form/freeze"
                    exact
                    component={() => {
                      return isFreezeIframeEnabled ? (
                        <FreezeMembershipIframe />
                      ) : (
                        <FreezeMembership />
                      );
                    }}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/membership-form/cancel"
                    exact
                    component={() => {
                      return isCancelIframeEnabled ? (
                        <CancelMembershipIframe />
                      ) : (
                        <CancelMembership />
                      );
                    }}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/manage-membership/cancel-membership"
                    exact
                    component={CancelMembership}
                    redirectTo={redirect}
                  />
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/notification"
                    exact
                    component={Notification}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={!isAuth}
                    path="/reset_password"
                    exact
                    component={ResetPasswordPage}
                  /> */}
                  <PrivateRoute
                    allow={!isAuth}
                    path="/reset_password"
                    exact
                    component={ResetPasswordPageNew}
                  />
                  <PrivateRoute
                    allow
                    path="/new_password"
                    exact
                    component={NewPasswordPage}
                  />
                  <PrivateRoute
                    allow
                    path="/magic-link-password"
                    exact
                    component={MagicLinkPassword}
                  />
                  {/* <PrivateRoute
                    allow
                    path="/request_success"
                    exact
                    component={RequestSuccessPage}
                  /> */}
                  <PrivateRoute
                    allow
                    path="/request_success"
                    exact
                    component={RequestSuccessPageNew}
                  />
                  <PrivateRoute
                    allow={allowLimited}
                    path="/set-password"
                    exact
                    component={SetPasswordPageNew}
                    redirectTo={redirect}
                  />
                  {/* <PrivateRoute
                    allow
                    path="/join"
                    exact
                    component={RegistrationPageNew}
                  /> */}
                  {/* <PrivateRoute
                    allow={!isAuth}
                    path="/experience-us"
                    exact
                    component={ExperienceUsPage}
                  /> */}
                  <PrivateRoute
                    allow
                    path="/create_success"
                    exact
                    component={CreateSuccessPage}
                  />
                  {/* <PrivateRoute
                    allow={!isAuth}
                    path="/login"
                    exact
                    component={LoginPage}
                    redirectTo="/"
                  /> */}
                  <PrivateRoute
                    allow={!isAuth}
                    path="/login"
                    exact
                    component={LoginPageNew}
                    redirectTo="/"
                  />
                  <PrivateRoute
                    allow={!isAuth}
                    path="/one-time-login-link"
                    exact
                    component={OneTimeLoginLink}
                  />
                  {/* <PrivateRoute
                    allow={allowLimited && isTablet}
                    path="/profile"
                    exact
                    component={ProfilePageMyAccount}
                    redirectTo="/my-account"
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/my-account"
                    exact
                    component={ProfilePageMyAccount}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/update-user-password"
                    component={ProfilePageUpdatePassword}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/membership-subscription"
                    component={ProfilePageMembershipSubscription}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/invite"
                    exact
                    component={InviteBenefitPage}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/billing-information"
                    exact
                    component={ProfilePageBilling}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/statements-transactions"
                    exact
                    component={ProfilePageTransaction}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/packages"
                    exact
                    component={ProfilePackages}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute */}
                  {/*  allow={allowLimited} */}
                  {/*  path="/contact-us" */}
                  {/*  exact */}
                  {/*  component={ProfilePageContactUs} */}
                  {/*  redirectTo={redirect} */}
                  {/* /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/settings"
                    exact
                    component={ProfileSettings}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited}
                    path="/checkin-history"
                    exact
                    component={ProfilePageHistory}
                    redirectTo={redirect}
                  /> */}
                  <PrivateRoute
                    allow={
                      isAuth && effectiveIsOnboardingDisplay && membershipRestrictions
                    }
                    path="/onboarding"
                    exact
                    component={OnboardingProcess}
                    redirectTo="/login"
                  />
                  {/* <PrivateRoute
                    allow={allowLimited && checkIsAdminRestrictions}
                    path="/admin"
                    exact
                    component={AdminPage}
                    redirectTo={redirect}
                  /> */}
                  {/* <PrivateRoute
                    allow={allowLimited && membershipRestrictions}
                    path="/qr"
                    exact
                    component={QrCodePage}
                    redirectTo={redirect}
                  /> */}
                  <PrivateRoute
                    allow={allowLimited}
                    path="/logout"
                    exact
                    component={Logout}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={!isAuth}
                    path="/our-classes"
                    exact
                    component={GuestClassesPage}
                    redirectTo={redirect}
                  />
                  <PrivateRoute
                    allow={isAuth || !isAuth}
                    path={tncPathname || '/documentsign'}
                    exact
                    component={PolicyScreen}
                    redirectTo={redirect}
                  />

                  {/* <PrivateRoute
                    allow={!isAuth}
                    path="/experience-us"
                    exact
                    component={() => {
                      window.location.replace(
                        'https://experience.fitnesssf.com/free-1-day-membership'
                      );
                      return null;
                    }}
                  /> */}
                  <PrivateRoute
                    allow={allowLimited}
                    path={['/view_statement', '/checkin_list']}
                    exact
                    redirectTo={redirect}
                  >
                    <Redirect to="/statement-checkins" />
                  </PrivateRoute>
                  <PrivateRoute
                    allow={allowLimited}
                    path="/home"
                    exact
                    redirectTo={redirect}
                  >
                    <Redirect to="/" />
                  </PrivateRoute>
                  <PrivateRoute
                    allow={allowLimited}
                    path="/hubspotform"
                    exact
                    redirectTo={redirect}
                  >
                    <Redirect
                      to={{
                        pathname: '/mvpTraining',
                        state: { mobileFormURL },
                      }}
                    />
                  </PrivateRoute>
                  <PrivateRoute
                    allow={mobileURL}
                    path={[
                      '/update-password',
                      '/my-account',
                      '/manage_memberShip',
                      '/mental_wellness',
                    ]}
                    exact
                    component={RedirectionPage}
                    redirectTo={redirect}
                  />
                  <Route path="*">
                    <NotFoundPage />
                  </Route>
                </Switch>
              </ScrollToTop>
            </React.StrictMode>
          </SmallMobileContext.Provider>
        </MobileContext.Provider>
      </TabletContext.Provider>

      {error && (
        <Message type={errorType} text={error} timeout={5000} onClose={clearError} />
      )}

      <TnCPopUp
        open={openTncPopUp}
        onClose={handlePopupClick}
        popupDetails={popupDetails}
        termsAgreementValues={termsAgreementValues}
        setOpenTncPopUp={setOpenTncPopUp}
      />

      <MobileContext.Provider value={isMobile}>
        <PolkMemberPopUp open={openPolkPopUp} setOpenPolkPopUp={setOpenPolkPopUp} />
      </MobileContext.Provider>

      <StatusPopup
        open={openStatusPopup}
        onClose={handleCloseStatusPopup}
        icon={rocket}
        iconAlt=""
        badgeText="Coming Soon"
        title={`Say hello to the new\nFitness SF APP`}
        items={[
          {
            icon: chartSpline,
            title: 'Clearer Progress',
            description: 'See your streaks and stats at a glance.',
          },
          {
            icon: sparkles,
            title: 'Cardi O. Virtual Assistant',
            description: 'It help for anything related to FITNESS SF.',
          },
          {
            icon: layoutGrid,
            title: 'A fresh new look',
            description: 'Redesigned, but all your feature still here.',
          },
        ]}
      />
    </>
  );
};

App.propTypes = {
  isAuth: PropTypes.bool.isRequired,
  // email: PropTypes.string.isRequired,
  // sfId: PropTypes.string.isRequired,
  // requestNotifications: PropTypes.func.isRequired,
  // receiveNotifications: PropTypes.func.isRequired,
  receiveMessage: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
  errorType: PropTypes.string.isRequired,
  clearError: PropTypes.func.isRequired,
  setMessage: PropTypes.func.isRequired,
  favoriteLocation: PropTypes.string.isRequired,
  isOnboardingDisplay: PropTypes.bool,
  memberStatus: PropTypes.string.isRequired,
  membership: PropTypes.array.isRequired,
  receiveReadMessages: PropTypes.func.isRequired,
  loadMessages: PropTypes.func.isRequired,
  messagesHistory: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.object),
    PropTypes.array,
  ]).isRequired,
  incomingCall: PropTypes.func.isRequired,
  incomingCallRejected: PropTypes.func.isRequired,
  isTrainer: PropTypes.bool.isRequired,
  vaccineStatus: PropTypes.string,
  loadTermsAgreementValues: PropTypes.func,
  loadPopupDetails: PropTypes.func,
};

App.defaultProps = {
  vaccineStatus: '',
  isOnboardingDisplay: false,
};

const mapStateToProps = state => ({
  isAuth: state.auth.isAuth,
  email: state.auth?.user?.email,
  sfId: state.auth?.user?.sfId,
  isTrainer: state.auth?.user?.isTrainer ? state.auth.user.isTrainer : false,
  error: state.error.message,
  errorType: state.error.type,
  favoriteLocation: state.auth?.isAuth ? state.auth.user.favoriteLocation : '',
  isOnboardingDisplay: state.auth?.isAuth ? state.auth.user.isOnboardingDisplay : false,
  memberStatus: state.auth?.isAuth ? state.auth.user.memberStatus : '',
  membership: state.auth?.membership || [],
  vaccineStatus: state.auth?.profile?.vaccineStatus,
  messagesHistory: state.messages.messagesHistory,
  hasIncomingCall: state.messages.hasIncomingCall,
  popupDetails: state?.termsAndConditions?.popupDetails,
  termsAgreementValues: state?.termsAndConditions?.termsAgreementDetails,
  formsDetails: state.membershipForms.formsDetails,
  cancelIframeDetails: state.membershipForms.cancelIframeDetails,
  freezeIframeDetails: state.membershipForms.freezeIframeDetails,
  isPolkMember: state.auth?.user?.isPolkMember || false,
});

const mapDispatchToProps = dispatch => {
  return {
    // requestNotifications: () => {
    //   dispatch(NotificationActions.Creators.requestNotifications());
    // },
    loadMessages: () => {
      dispatch(MessageActions.Creators.loadMessagesRequest());
    },
    // receiveNotifications: data =>
    // dispatch(NotificationActions.Creators.receiveNotifications(data)),
    receiveMessage: data => dispatch(MessageActions.Creators.receiveMessage(data)),
    receiveReadMessages: data =>
      dispatch(MessageActions.Creators.receiveReadMessages(data)),
    clearError: () => {
      dispatch(ErrorActions.Creators.clearError());
    },
    setMessage: data => {
      dispatch(ErrorActions.Creators.setMessage(data));
    },
    incomingCall: (friendId, friendSocketId) => {
      dispatch(SessionCallActions.Creators.incomingCall(friendId, friendSocketId));
    },
    incomingCallRejected: () => {
      dispatch(SessionCallActions.Creators.incomingCallRejected());
    },
    loadTermsAgreementValues: userId => {
      dispatch(termsAndConditionsActions.Creators.getTermsAgreementRequest(userId));
    },
    loadPopupDetails: userId => {
      dispatch(termsAndConditionsActions.Creators.loadPopupDetailsRequest(userId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
